<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="FM-Head-fmh"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample">acknowledgments</span></p>
<p class="Text-Std-No-Indent-tx1">Writing a book—like planning a wedding—takes a lot of time, patience, and the sometimes irrational belief that it will all work out in the end. I want to thank the following people who helped walk me down the aisle: My agent, Adam Chromy, whose early notes helped give this book its heart and soul; Dan Weiss, who heard my idea for <span class="ePub-I">The Wedding Sisters</span> over lunch and said let’s do it; my editor, Vicki Lame, who patiently gave me what I needed for this one: time to figure it out! And my college friend Dana Bash, who in making time to say “hi” one busy workday, gave me an unexpected but invaluable behind-the-scenes look at political journalism. A special thanks to professor and memoirist Dori Katz, who so candidly and generously shared her story with the congregants at Temple Emanu-El and inspired me greatly.</p>
<p class="Text-Standard-tx">Thanks to my daughters, Bronwen and Georgia, who show me—every day—the remarkable beauty of sisterhood.</p>
<p class="Text-Standard-tx">Finally, I thank my beloved husband, who makes my dreams come true.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?d0e83f9e